import React from "react";

export const VcoinMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="22" stroke="#C9A84C" strokeWidth="2" />
    <circle cx="24" cy="24" r="15" stroke="#C9A84C" strokeWidth="1" opacity="0.5" />
    <path d="M15 17L24 33L33 17" stroke="#C9A84C" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Wordmark = ({ light = false }) => (
  <div className="flex items-center gap-2.5">
    <img src="/vcoin-logo.png" alt="Vcoin" className="h-9 w-9 object-contain" />
    <span
      className="font-playfair text-xl tracking-tight"
      style={{ color: light ? "#F7F5F0" : "#1B2B5E" }}
    >
      Vcoin
    </span>
  </div>
);
